var React = require('react');

function Dot (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"4.5","cy":"5","r":"4.5","fill":"currentColor"}));
}

Dot.defaultProps = {"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none"};

module.exports = Dot;

Dot.default = Dot;
